export const getLeadList = state => {
    return state.list
}

export const getLeadDataProps = state => {
    return state.props
}


// WEBPACK FOOTER //
// ./src/store/modules/leads/getters.js